import { z } from 'zod'

/** `?volta=` das telas de entrada: para onde ir depois de entrar. */
export const voltaSearch = z.object({
  volta: z.string().max(500).optional().catch(undefined),
})

/**
 * Só aceita caminho interno do próprio lado. Sem isso, um link com
 * `?volta=https://...` levaria a pessoa para fora logo depois do login.
 */
export function destinoDeVolta(volta: string | undefined, area: '/app' | '/portal'): string {
  if (volta === undefined) return area
  const dentro = volta === area || volta.startsWith(`${area}/`) || volta.startsWith(`${area}?`)
  const externo = volta.startsWith('//') || volta.includes('\\')
  if (!dentro || externo || volta.startsWith(`${area}/entrar`)) return area
  return volta
}
